export const baseUrl = 'https://api.monitoring.gameopedia.com'
export const FLIP_IS_LOADING = 'FLIP_IS_LOADING';
export const RECEIVE_TEAMS = 'RECEIVE_TEAMS';



// WEBPACK FOOTER //
// ./src/shared/javascripts/constants.js